import { OnDestroy, Directive, TemplateRef, ViewContainerRef, Input, HostListener } from '@angular/core';
import { ClubTagQuery, CustomerTag } from '@fgb/core';
import { Subscription } from 'rxjs';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[hasTag]',
})
/**
 * Example usage - *hasTag="tags.club; checkValue: false"
 */
export class HasTagDirective implements OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private clubTagQuery: ClubTagQuery
  ) {}

  private tagSub: Subscription;

  @Input() hasTag: CustomerTag;

  @Input() hasTagCheckValue: boolean = true;

  ngOnChanges(): void {
    if (!this.hasTag) {
      return;
    }
    this.tagSub = this.clubTagQuery.selectUserHasTag(this.hasTag, this.hasTagCheckValue).subscribe((result) => {
      this.viewContainer.clear();
      if (result) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    if (this.tagSub) {
      this.tagSub.unsubscribe();
    }
  }
}
